module.exports = __webpack_public_path__ + "img/2_Appendix.a13c78c3.png";